import thumbnail_4 from '../collegeChoice101/thumbnail.png';

import image0 from '../collegeChoice101/0.png';
import image1 from '../collegeChoice101/1.png';
import image2 from '../collegeChoice101/2.png';
import image3 from '../collegeChoice101/3.png';
import image4 from '../collegeChoice101/4.png';
import image5 from '../collegeChoice101/5.png';
import image6 from '../collegeChoice101/6.png';


export const CollegeChoice101 = {
  id:2,
  type: 'web',
  thumbnails: [thumbnail_4],
  screens: [image0, image1, image2, image3, image4, image5,image6],
  title: 'College Choice 101 – Smarter College Decisions for Students in the USA',
  intro:
    "College Choice 101 is an interactive web platform built to help students in the United States make smarter, data-driven decisions about their future education. From comparing universities and calculating ROI to exploring rankings and financial outcomes, it offers a personalized experience to guide students and families through one of life’s most important choices.",
  features: [
    {
      title: "University Comparison Tool",
      description:
        "Compare colleges side by side based on tuition, graduation rate, location, average salary after graduation, acceptance rate, and more. Easily spot the best academic and financial fit for your goals."
    },
    {
      title: "ROI Calculator Based on Your Inputs",
      description:
        "Enter your initial funds, expected student loans, and estimated starting salary to calculate a personalized return on investment. Understand the long-term financial impact of each college decision."
    },
    {
      title: "National & Program-Specific Rankings",
      description:
        "Explore up-to-date rankings for overall universities, specific majors, and career outcomes. Make informed choices based on reputation, outcomes, and real-world value."
    },
    {
      title: "Financial Aid & Scholarship Insights",
      description:
        "Learn how much aid schools typically offer based on income, merit, and residency. Access tools that show potential scholarships and net cost after aid."
    },
    {
      title: "Saved Comparisons & Personalized Lists",
      description:
        "Create a shortlist of your favorite colleges and return to compare them anytime. Customize your view with filters like location, major, or cost."
    },
    {
      title: "Articles, Guides, and Planning Resources",
      description:
        "Stay informed with regularly updated content on college planning, financial aid strategies, admission timelines, and career path insights — written by education experts."
    },
    {
      title: "User-Friendly Design for Students & Parents",
      description:
        "Built for clarity and ease of use, the platform guides users step by step without overwhelming them. Perfect for both first-time college applicants and returning adult learners."
    }
  ],
  conclusion:
    "College Choice 101 empowers students to make confident, informed decisions about where to go to college and how to pay for it. With powerful tools, personalized ROI analysis, and expert insights, it helps students invest in the future that’s right for them — academically and financially."
};
